import { render, staticRenderFns } from "./DeviceInfoAdequacaoTop.vue?vue&type=template&id=8b2ca11a&"
import script from "./DeviceInfoAdequacaoTop.vue?vue&type=script&lang=js&"
export * from "./DeviceInfoAdequacaoTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports